import { Button, Layout } from 'components'
import { useEffect, useState } from 'react'
import styles from './AccountingPage.module.scss'

import { useDispatch, useSelector } from 'react-redux'

import right from 'assets/icons/chevron_right.png'

import { useLocation, useNavigate } from 'react-router-dom'

import ReceiptsContent from './components/ReceiptsContent';
import ExpensesContent from './components/ExpensesContent';
import StudentsContent from './components/StudentContent/StudentsContent';
import EmployeeContent from './components/EmployeeContent/EmployeeContent';
import ContractAmountContent from './components/ContractAmountContent';
import AccountingPageStruct from './AccountingPageStruct';

import { getAccountingDetailData, getCheckData } from "service/AccountingService";

import userInfo from 'utils/userInfo'
const AccountingDataPage = () => {
  const navigate = useNavigate()
  const sections = [
    { key: "receipts", label: "Поступления", Component: ReceiptsContent },
    { key: "expenses", label: "Расходы", Component: ExpensesContent },
    { key: "students", label: "Обучающиеся", Component: StudentsContent },
    { key: "employee", label: "Сотрудники", Component: EmployeeContent },
    { key: "contractamount", label: "Суммы контракта", Component: ContractAmountContent },
    { key: "administration", label: "Администрирование", Component: AccountingPageStruct },
  
  ];

  const [activeSection, setActiveSection] = useState(null);

  const handleShowSection = (key) => {
    setActiveSection(prev => (prev === key ? null : key));
  };


  const [render, setRender] = useState(false)
  const location = useLocation()
  const [id, setId] = useState(null);
  const [data, setData] = useState([]);
  const [datacheck, setDataCheck] = useState([]);
  const getData = async (id) => {
    try {
      let response = await getAccountingDetailData(id, data);
      let responsecheck = await getCheckData(id, data);
      setData(response.data);
      setDataCheck(responsecheck.data);

    } catch (error) {
      console.log("onoxo")
    }
  };

  useEffect(() => {
    if (location.state && location.state.usedId) {

      const usedId = location.state.usedId;

      setId(usedId)

      getData(usedId);

      setRender(false);
    } else {

      navigate("/accounting");
    }


  }, [render, location.pathname, location.state]);

  return (
    <Layout>
      <div className={styles.project__container}>
        <div className={styles.project__wrapper}>
          <div className={styles.project__header}>
            <div className={styles.title}>
              Бухгалтерия
              <img
                src={right}
                alt=""
                style={{
                  paddingLeft: '10px',
                  paddingRight: '10px',
                  verticalAlign: 'middle',
                }}
              />
              {data.fund_name}
            </div>
            <Button className={styles.btn_pin} onClick={() => navigate("/accounting/")}>
              Вернуться
            </Button>
          </div>
          <div className={styles.project__body}>
            <h2 className={styles.project_w}>Остаток: <span>{data.balance}</span></h2>
            <h2 className={styles.project_w}>Поступления:  <span>{data.total_income}</span></h2>
            <h2 className={styles.project_w}>Расходы:  <span>{data.total_expense}</span></h2>

          </div>
          {/* <div className={styles.project__body}>
            {sections.map(({ key, label }) => (
              <div key={key} className={styles.project__card}>
                <h2>{label}</h2>
                {activeSection === key ? (
                  <Button
                    className={styles.btn_pin}
                    onClick={() => handleShowSection(null)}
                  >
                    Закрыть
                  </Button>
                ) : (
                  <Button
                    className={styles.btn_pin}
                    onClick={() => handleShowSection(key)}
                  >
                    Просмотреть
                  </Button>
                )}
              </div>
            ))}
          </div> */}
          <div className={styles.project__body}>
            <div className={styles.project__menu}>
              {sections.map(({ key, label }) => (
                <div key={key} className={
                  activeSection === key
                    ? styles.project__menu__item__active
                    : styles.project__menu__item
                }>
                  <h2
                    onClick={() =>
                      handleShowSection(activeSection === key ? null : key)
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    {label} {activeSection === key ? '🔼' : '🔽'}
                  </h2>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.project__body}>
            {sections.map(({ key, Component }) =>
              activeSection === key && Component ? (
                <Component
                  key={key}
                  render={render}
                  setRender={setRender}
                  datacheck={datacheck}
                  id={id}
                />
              ) : null
            )}
          </div>
        </div>
      </div>

    </Layout>
  )
}

export default AccountingDataPage
